/**
 * @param {*} raw
 * @return {?userModel.type}
 */
export const userModel = (raw) => {
  return raw
    ? {
        id: raw.id || null,
        name: raw.name || '',
        email: raw.email || '',
      }
    : null;
};

/**
 * @typedef {{
 *   id: number,
 *   name: string,
 *   email: string,
 * }}
 */
userModel.type = null;
